import { h, JSX, Fragment } from 'preact';
import OrdinalDate from 'src/components/ordinal-date';

export type LuckyChatsVariation = 'lucky-chats' | 'spooky-chats' | 'naughty-chats';

export interface Variation {
    title: string;
    description: string;
    heroDescription: string;
    infoTitle: string;
    infoDescription: string;
    listTitle: string;
    listWaitText: (date: number | undefined) => JSX.Element;
    explanationTitle: string;
    explanation: JSX.Element;
    rulesTitle: string;
    rules: JSX.Element;
}

export const ACTIVE_VARIATION: LuckyChatsVariation = 'lucky-chats';

const Variations: Record<LuckyChatsVariation, Variation> = {
    'lucky-chats': {
        title: 'Lucky Chats',
        description: 'Newest and most exciting promotion!',
        heroDescription: 'Over 250 prizes in 24hrs!',
        infoTitle: 'Newest and most exciting promotion!',
        infoDescription: 'Every 10 minutes, a random lucky live session will win a random prize from $50.00 to $500.00!',
        listTitle: 'Lucky Chats Prize Winners',
        listWaitText: (date: number | undefined) => {
            return (
                <p>
                    There are no winners yet, as the promo starts on <OrdinalDate datetime={date} />, 00:00 GMT
                </p>
            );
        },
        explanationTitle: 'Explanation',
        explanation: (
            <>
                <p>Introducing Lucky Chats, CC's newest and most exciting promotion!</p>
                <p>Every 10 minutes, a random lucky live session will win a random prize in our shared pool of over 250 prizes in just 24 hours. CC is giving away prizes ranging from $50 all the way up to $500.</p>
                <p>All you have to do is be in a live video session during our Lucky Chats promotion for your chance to win. Strike it lucky with Lucky Chats!</p>
            </>
        ),
        rulesTitle: 'Rules',
        rules: (
            <ul>
                <li>Promo valid for 24 hours 00:00 - 23:59 GMT</li>
                <li>All Members and Chathosts are eligible for a prize</li>
                <li>Random shared prizes awarded every 10 minutes</li>
                <li>Random Shared Prizes awarded to Members & Chathosts in live video sessions only</li>
                <li>Prizes range from $50.00 to $500.00</li>
                <li>Member prizes awarded as CamContacts credits</li>
                <li>Member prizes cannot be exchanged for cash</li>
            </ul>
        ),
    },
    'spooky-chats': {
        title: 'Spooky Chats',
        description: 'Our most Spook-tacular Halloween promo!',
        heroDescription: 'Over 250 prizes in 24hrs!',
        infoTitle: 'Our most Spook-tacular Halloween promo',
        infoDescription: 'Every 10 mins, a random live video session will win a prize of $50.00 to $500.00',
        listTitle: 'Spooky Chats Prize Winners',
        listWaitText: (date: number | undefined) => {
            return (
                <p>
                    Promo starts on <OrdinalDate datetime={date} /> at 00:00 GMT, winning Chat-Ghosts & members will eerily appear here then
                </p>
            );
        },
        explanationTitle: 'Explanation',
        explanation: (
            <>
                <p>Introducing Spooky Chats, it's like Lucky Chats but this time it is for all our Chat-Ghosts and members that go bump in the night.</p>
                <p>During Spooky Chats something eerie is happening during live sessions. Every 10 mins a random couple will win a shared prize from $50 up to a spook-tacular $500.</p>
                <p>All you have to do is be in a live video for a chance to win & make this a Happy Halloween!</p>
            </>
        ),
        rulesTitle: 'Ghouls & Regulations',
        rules: (
            <ul>
                <li>Promo valid for 24 hours 00:00 - 23:59 GMT</li>
                <li>All Members and Chathosts are eligible for a prize</li>
                <li>Random shared prizes awarded every 10 minutes</li>
                <li>Random Shared Prizes awarded to Members & Chathosts in live video sessions only</li>
                <li>Prizes range from $50.00 to $500.00</li>
                <li>Member prizes awarded as CamContacts credits</li>
                <li>Member prizes cannot be exchanged for cash</li>
            </ul>
        ),
    },
    'naughty-chats': {
        title: 'Naughty Chats',
        description: 'Our Cheeky Festive Promo for those who are on the Naughty list!',
        heroDescription: 'Over 250 prizes in 24hrs!',
        infoTitle: 'Our Cheeky Festive Promo for those who are on the Naughty list!',
        infoDescription: 'Every 10 mins, a random live video session will win a prize of $50.00 to $500.00',
        listTitle: 'Naughty Chats Prize Winners',
        listWaitText: (date: number | undefined) => {
            return (
                <p>
                    Promo starts on <OrdinalDate datetime={date} /> 00:00 GMT, winning Chathosts & members will magically appear here then.
                </p>
            );
        },
        explanationTitle: 'Explanation',
        explanation: (
            <>
                <p>Introducing Naughty Chats, our festive promo for all those on the Naughty list.</p>
                <p>During Naughty Chats something magical will happen in live CamContacts video sessions. Every 10 minutes or less a random couple will win a shared prize from $50.00 up to a sack bulging $500.00.</p>
                <p>All you have to do to have a chance to win is be in a live video session.</p>
                <p>So grab your misteltoe, jingle your bells and join the fun.</p>
                <p>NB: Nice list members can join in too.</p>
            </>
        ),
        rulesTitle: 'T&Cs',
        rules: (
            <ul>
                <li>Promo valid for 24 hours 00:00 - 23:59 GMT</li>
                <li>All Members and Chathosts are eligible for a prize</li>
                <li>Random shared prizes awarded every 10 minutes</li>
                <li>Random Shared Prizes awarded to Chathost & viewers in live video sessions only</li>
                <li>Prizes range from $50.00 to $500.00</li>
                <li>Member prizes awarded as CamContacts credits</li>
                <li>Member prizes cannot be exchanged for cash</li>
            </ul>
        ),
    },
};

export default Variations;
